'use strict';

var React = require('react');
var isBrowser = require('./is-browser.cjs');

const useIsomorphicLayoutEffect = isBrowser.isBrowser ? React.useLayoutEffect : React.useEffect;

exports.useIsomorphicLayoutEffect = useIsomorphicLayoutEffect;
//# sourceMappingURL=use-isomorphic-effect.cjs.map
